module.exports = __webpack_public_path__ + "static/media/icon02.d682ce59.svg";